function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import _Input from "antd/es/input";
var _excluded = ["truncateMaxLength", "maxLength", "validCharacter", "id", "value", "defaultValue", "placeholder", "disabled", "rows", "style", "onChange", "onBlur", "onFocus"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useMemo } from 'react';
import { isSafeInteger } from 'lodash';
import classnames from 'classnames';
import './index.less';
var INPUT_STYLE = {
  flex: 1,
  padding: 0,
  boxShadow: 'none'
};
export var isChinese = function isChinese(str) {
  var reg = /[u00-uFF]/;
  return !reg.test(str);
};
export var calcCharacterlen = function calcCharacterlen(str) {
  if (!str) return 0;
  var strlength = 0;
  for (var i = 0; i < str.length; ++i) {
    if (isChinese(str.charAt(i)) == true) strlength = strlength + 2;
    //中文计算为一个字符
    else strlength = strlength + 1;
  }
  return strlength;
};
var OneTextarea = function OneTextarea(_ref) {
  var truncateMaxLength = _ref.truncateMaxLength,
    maxLength = _ref.maxLength,
    validCharacter = _ref.validCharacter,
    id = _ref.id,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    rows = _ref.rows,
    style = _ref.style,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocus = _useState2[0],
    setIsFocus = _useState2[1];
  var _useState3 = useState(value || defaultValue),
    _useState4 = _slicedToArray(_useState3, 2),
    innerValue = _useState4[0],
    setValue = _useState4[1];
  var defaultRow = 3;

  // 如果嵌套在Form.Item内，id自动获取name
  var handleChange = function handleChange(e) {
    setValue(e.target.value);
    onChange && onChange(e);
  };
  var handleBlur = function handleBlur(e) {
    onBlur && onBlur(e);
    setIsFocus(false);
  };
  var handleFocus = function handleFocus(e) {
    onFocus && onFocus(e);
    setIsFocus(true);
  };
  var valueLength = useMemo(function () {
    var v = innerValue || value || defaultValue;
    if (validCharacter) {
      return calcCharacterlen(v);
    }
    return v ? v.length : 0;
  }, [innerValue, value, defaultValue, validCharacter]);
  var hasMaxLength = isSafeInteger(maxLength) && maxLength > 0;
  var hasMaxLengthError = hasMaxLength && valueLength > maxLength;
  var className = classnames('ant-input', 'one-textarea-box', {
    'ant-input-focused': isFocus,
    'ant-input-disabled': disabled
  });
  var renderTextArea = function renderTextArea() {
    return /*#__PURE__*/React.createElement(_Input.TextArea, _extends({
      disabled: disabled,
      id: id,
      name: id,
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: handleFocus,
      placeholder: placeholder,
      maxLength: truncateMaxLength ? maxLength : undefined,
      rows: rows || defaultRow,
      style: _objectSpread(_objectSpread({}, INPUT_STYLE), style || {}),
      value: value,
      bordered: false
    }, rest));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, renderTextArea(), hasMaxLength ? /*#__PURE__*/React.createElement("div", {
    className: classnames('one-textarea-countdown', hasMaxLengthError && 'one-textarea-has-error')
  }, /*#__PURE__*/React.createElement("span", null, valueLength), "/", maxLength) : null);
};
export default OneTextarea;